<h1 mat-dialog-title class="w-100">Kopiowanie szablonu transportu</h1>
<h3 mat-dialog-title class="w-100">Możesz teraz zmienić nazwę kopiowanego szablonu</h3>
<mat-dialog-content class="mat-typography pb-1 min-h-[320px]">
	<form [formGroup]="transportTemplateForm">
		<mat-form-field class="w-100">
			<input matInput type="text" placeholder="Nazwa szablonu transportu" formControlName="name" required />
			@if (
				transportTemplateForm.controls['name'].touched &&
				transportTemplateForm.controls['name'].errors?.required
			) {
				<mat-error>Nazwa jest wymagana</mat-error>
			}
		</mat-form-field>
	</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close class="bag-transport-template-copy-deny-button">
		Anuluj
	</button>
	<button
		[disabled]="transportTemplateForm.invalid"
		mat-raised-button
		class="transport-template-copy-save-button"
		color="primary"
		(click)="save()"
	>
		Zapisz
	</button>
</mat-dialog-actions>
